// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"securityBadge_wrapper___Cji4","svg":"securityBadge_svg__38yOW"};